import { Button, Modal } from 'antd';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { cleanDetalhesNota, itensNotaRequest } from '../../../../store/ducks/movimentacoes/actions';
import { ItensNotaProps } from './props';
import { CloseOutlined } from '@ant-design/icons';
import { maskCurrency, maskUnd } from '../../../../utils/mask';
import Table, { ColumnType } from 'antd/lib/table';
import { useWindowSize } from '../../../../hook/useWindowSize';
import CardMobile from './CardMobile';

const ModalNotaDetalhes: React.FC<ItensNotaProps> = ({ text, nuNota, chave }) => {
  const loadingItensNotaEntrada = useSelector(
    (state: ApplicationState) => state.Movimentacoes.loading
  );
  const itensNotaEntrada = useSelector(
    (state: ApplicationState) => state.Movimentacoes.itensNotaEntrada
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch<Dispatch<Action>>();

  const showModal = (numNota: number) => {
    setIsModalVisible(true);
    dispatch(itensNotaRequest(numNota));
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    dispatch(cleanDetalhesNota());
  };
  const { width }: any = useWindowSize();

  let columnsModal: ColumnType<object>[] = [
    {
      title: 'Código produto',
      dataIndex: 'codProduto',
      key: 'codProduto',
    },
    {
      title: 'Código referência',
      dataIndex: 'referencia',
      key: 'referencia',
    },
    {
      title: 'Produtos',
      dataIndex: 'descricaoProduto',
      key: 'descricaoProduto',
    },
    {
      title: 'Lote',
      dataIndex: 'controle',
      key: 'controle',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      render: (text: number = 0) => {
        return maskUnd(text);
      },
    },
    {
      title: 'Unidade',
      dataIndex: 'volume',
      key: 'volume',
    },
    {
      title: 'Peso bruto',
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      render: (text: number = 0) => {
        return maskUnd(text) + ' KG';
      },
    },
    {
      title: 'Valor total',
      dataIndex: 'valorTotal',
      key: 'valorTotal',
      render: (text: number = 0) => {
        return maskCurrency(text);
      },
    },
  ];

  return (
    <>
      <Modal
        centered
        title={`Lista de produtos - NF-${text} ${chave ? '- Chave da nota: ' + chave : ''}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleCancel}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={1300}
        footer={
          <Button onClick={handleCancel} type="primary">
            Fechar
          </Button>
        }
      >
        {width > 768 && (
          <Table
            style={{ fontSize: 10, display: 'inline', width: '100%' }}
            scroll={{ x: 1200 }}
            columns={columnsModal}
            size={'large'}
            pagination={{
              defaultPageSize: 3,
              defaultCurrent: 1,
              showSizeChanger: true,
              pageSizeOptions: ['3', '5', '10', '20', '50'],
              locale: { items_per_page: '/ página' },
            }}
            dataSource={itensNotaEntrada}
            loading={loadingItensNotaEntrada}
            className="table"
            rowKey={'nuNota'}
          />
        )}
        {width <= 768 && <CardMobile />}
      </Modal>

      <button
        style={{
          padding: 0,
          height: 'auto',
          border: 'none',
          background: 'none',
          color: '#1890ff',
          cursor: 'pointer',
        }}
        onClick={() => showModal(nuNota ?? 0)}
      >
        {text}
      </button>
    </>
  );
};

export default ModalNotaDetalhes;
